import React, {useEffect} from "react"
import Theme from "../../library/Theme"
import StickerDropzone from "./StickerDropzone"
import * as StickerUtil from "../../utils/StickerUtil"

interface EditImagePreviewProps {
  userImage: string
  currentOverlayUrl: string | null
  currentBackgroundUrl: string | null
}

export default function EditImagePreview({ userImage, currentOverlayUrl, currentBackgroundUrl }: EditImagePreviewProps) {
  useEffect(() => {
    document.onmouseup = StickerUtil.onMouseUp
    document.ontouchcancel = StickerUtil.onMouseUp
    document.ontouchend = StickerUtil.onMouseUp

    return () => {
      document.onmouseup = null
      document.ontouchcancel = null
      document.ontouchend = null
    }
  }, [])

  return (
    <div className="boothContainer">
      <StickerDropzone/>

      <div className="square">
        {currentOverlayUrl !== null &&
          <img id="overlayImage" crossOrigin="anonymous" src={currentOverlayUrl} className="overlay fill stretch" alt="Overlay"/>
        }

        <div className="layer">
          {userImage &&
            <img id="userImage" crossOrigin="anonymous" src={userImage} className="foregroundImage fill" alt="Preview"/>
          }
        </div>

        {currentBackgroundUrl != null &&
          <img id="selectedBackground" crossOrigin="anonymous" src={currentBackgroundUrl} className="backgroundImage fill stretch" alt="Background"/>
        }
      </div>
    </div>
  )
}
